import { ALL_FILTERS } from "src/Modules/Hotels/constants";
import { DYNAMIC_FILTERS, STATIC_FILTERS } from "src/Modules/Hotels/constants";

const transformFormToFilters = (allValues: Record<string, any>) => {
  const result: Record<string, any> = {};
  const isEmptyFilterValue = (value: any) => value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0);

  Object.entries(allValues).forEach(([key, value]) => {
    if (isEmptyFilterValue(value)) return;
    const filter = ALL_FILTERS.find((f) => f.key === key);
    if (!filter) return;
    if (filter.op === "between") {
      const [valueFrom, valueTo] = value;
      if (valueFrom === undefined && valueTo === undefined) return;
      result[key] = { valueFrom, valueTo };
    } else {
      result[key] = { value };
    }
  });
  return result;
};

const transformFormToSorters = (sorter: any) => {
  return Object.entries(sorter).map(([key, value]) => {
    return {
      key,
      asc: value,
    };
  })?.[0];
};

const generateNoneFilterValues = (dataGroups:any)=>{
  const staticFilters = [...STATIC_FILTERS].reduce(
    (acc, filter) => {
      if (filter.op === "between") {
        acc[filter.key] = undefined;
      } else {
        acc[filter.key] = undefined;
      }
      return acc;
    },
    {} as Record<string, any>,
  );
  const dynamicFilters = [...DYNAMIC_FILTERS].reduce(
    (acc, filter) => {
      if (dataGroups?.get(filter.key)) {
        if (filter.op != "between") {
          acc[filter.key] = [];
        } else {
          acc[filter.key] = [undefined, undefined];
        }
      }
      return acc;
    },
    {} as Record<string, any>,
  );
  return {
    ...staticFilters,
    ...dynamicFilters,
  };
};

const generateInitialFilterValues = (dataGroups: any) => {
  const staticFilters = [...STATIC_FILTERS].reduce(
    (acc, filter) => {
      if (filter.op === "between") {
        acc[filter.key] = undefined;
      } else {
        acc[filter.key] = undefined;
      }
      return acc;
    },
    {} as Record<string, any>,
  );
  const dynamicFilters = [...DYNAMIC_FILTERS].reduce(
    (acc, filter) => {
      if (dataGroups?.get(filter.key)) {
        if (filter.op != "between") {
          acc[filter.key] = [];
        } else {
          const values = Array.from([...dataGroups.get(filter.key).keys()])?.map((item: any) => item);
          acc[filter.key] = [Math.min(...values), Math.max(...values)];
        }
      }
      return acc;
    },
    {} as Record<string, any>,
  );
  return {
    ...staticFilters,
    ...dynamicFilters,
  };
};




export {transformFormToFilters,transformFormToSorters, generateInitialFilterValues, generateNoneFilterValues}